import { Phase3, ContractStatus } from '@indigo-ag/schema';

export class Phase3Util {
  static isDraftDone(phase3: Phase3): boolean {
    return !!phase3.draftSentAt;
  }

  static isSignedDocuments(phase3: Phase3): boolean {
    return !!phase3.signedDocumentsReceivedAt;
  }

  static isValidatingDone(phase3: Phase3, hasConditionals: boolean): boolean {
    const contractSigned = phase3?.contractStatus === ContractStatus.SIGNED_DOCUMENTS_APPROVED;
    if (!contractSigned) {
      return false;
    }

    if (hasConditionals) {
      return !!phase3.approvedConditionals;
    }

    return true;
  }

  static hasReceivedPhysicalDocuments(phase3: Phase3): boolean {
    return !!phase3.physicalDocumentsReceivedAt;
  }

  static canRestartPhase2(phase3: Phase3, isInternal: boolean): boolean {
    return isInternal && !phase3?.draftSentAt;
  }
}
